import { useSelector, useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import {
  Col,
  Container,
  Row,
  Button,
} from "reactstrap";
import FormHelpers from "../../helpers/FormHelpers";

import CardPreview from "../Cards/CardPreview"
import { configuratorActions } from "../../store/configurator-slice";
import { sendCartData } from "../../store/configurator-actions";

function ApproveForm() {
  const dispatch = useDispatch();

  // get current request state
  const currentRequest = useSelector(
    (state) => state.configurator.ConfiguratorRequest
  );
  const requestDetails = currentRequest.DonorRequest;
  let cardType = "nocard";
  if(requestDetails.CardTypeValue === "sendtome") {
    cardType = "cards";
  } else if(requestDetails.CardTypeValue === "sendtosomeone" || requestDetails.CardTypeValue === "ecard") {
    cardType = "card";
  }

  const currentProductState = currentRequest.Products[cardType];
  const currentPreviewState = useSelector((state) => state.cardPreview);

  const approveHandler = (values) => {
    // get current donor request
    let currentCart = { ...requestDetails };
    let currentPreview = { ...currentPreviewState };
    let currentProduct = { ...currentProductState };
    dispatch(sendCartData(currentCart, currentPreview, currentProduct));

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const makeChangesClickHandler = (values) => {
    dispatch(configuratorActions.setFormStep("Request"));
    FormHelpers.scrollToTop();
  };

  const previousClickHandler = (values) => {
    const cardTypeValue = requestDetails.CardTypeValue;
    let prevStep = "Personalize";
    if (cardTypeValue === "ecard") {
      prevStep = "EcardRecipient";
    } else {
      if (cardTypeValue === "sendtosomeone") {
        prevStep = "Return";
      } else {
        prevStep = "Recipient";
      }
    }
    dispatch(configuratorActions.setFormStep(prevStep));
    FormHelpers.scrollToTop();
  };

  return (
    <div className="cfg-input-form cfg-approve" data-step="approve">
      <Formik>
        {({ values, errors, touched }) => (
          <Form className="text-start">
            <Container className="cfg-form-section">
            <Row className="mobile-only">
                <Col xs="12">
                  <CardPreview
                    zoom={0.29}
                    showCard={true}
                    showEnvelope={true}
                    preview={true}
                    approve={true}
                  />
                </Col>
              </Row>
              <Row className="text-center">
                <Col xs="12">
                  <div className="alert alert-primary" role="alert">
                    The card will be sent exactly as it appears.
                    <br />
                    Please review it carefully.
                  </div>
                </Col>
              </Row>
            </Container>
            
            <div className="mb-3">
            <Button
              type="button"
              size="sm"
              color="primary"
              onClick={previousClickHandler}
              className="btn-secondary"
              style={{minWidth:'132px'}}
            >
              Previous
            </Button>{" "}
            <Button
              type="button"
              size="sm"
              color="primary"
              onClick={makeChangesClickHandler}
              className="btn-secondary float-end"
            >
              Make Changes
            </Button>
            </div>
            <div className="text-center">
            <Button
              type="button"
              size="sm"
              color="primary"
              onClick={approveHandler}
            >
              I Approve
            </Button>
            </div>
            
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ApproveForm;
